import { useState } from "react";

interface CreateModalState {
  create: boolean;
}

export const useCreateModal = () => {
  const [modals, setModals] = useState<CreateModalState>({
    create: false,
  });

  const openCreate = () => {
    setModals((prev) => ({ ...prev, create: true }));
  };

  const closeCreate = () => {
    setModals((prev) => ({ ...prev, create: false }));
  };

  const closeAll = () => {
    setModals({ create: false });
  };

  return {
    modals,
    openCreate,
    closeCreate,
    closeAll,
  };
};
